import { LoadableContent } from 'utils/status';

export type UnderlyingsBloomberCode = {
  underlyingBloombergCode: string;
};

export type UnderlyingsDatesKey = UnderlyingsBloomberCode & {
  productType: string;
  productSubType: string;
};

export type OnBehalfClient = {
  bdrLegalId: string;
  bdrName: string;
  eliot: string;
  countryResidenceCode: string;
};

export type UnderlyingsDatesBlackoutDatesState = UnderlyingsBloomberCode & {
  blackoutDates: string[];
};
export type UnderlyingsDatesSpecificDatesState = UnderlyingsBloomberCode & { specificDates: string[] };

export type UnderlyingsDatesMapStateValue = UnderlyingsDatesSpecificDatesState | UnderlyingsDatesBlackoutDatesState;
export type UnderlyingsDatesMapState = IDictionary<LoadableContent<UnderlyingsDatesMapStateValue>>;
export const initialUnderlyingsDatesMapState = {} as UnderlyingsDatesMapState;
export const initialUnderlyingsDatesMapStateValue = {} as UnderlyingsDatesMapStateValue;
export type UnderlyingsDatesSpecificDatesResponse = {
  underlyingBloombergCode: string;
  specificDates: string[];
};
export type UnderlyingsDatesBlackoutDatesResponse = {
  underlyingBloombergCode: string;
  blackoutDates: string[];
};

export type UnderlyingsDatesPayload = UnderlyingsDatesKey & {
  onBehalfClient: OnBehalfClient;
  instrumentName?: string;
  instrumentContractName?: string;
};
